<div class="card-primary">
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
  <h1>{{ 'case.create-quiz-information.title' | translate | capitalize }}</h1>
  <p>
    {{ 'case.create-quiz-information.description' | translate | capitalize }}
  </p>
  <br />
  <p class="bold">
    {{ 'case.create-quiz-information.user-info-form.title' | translate | capitalize }}
  </p>
  <p>
    {{ 'case.create-quiz-information.user-info-form.description' | translate | capitalize }}
  </p>
  <ul>
    <li>USER_ID</li>
    <li>CASE_ID</li>
    <li>TENANT_ID</li>
  </ul>
  <p>
    {{ 'case.create-quiz-information.user-info-form.description2' | translate | capitalize }}
  </p>
  <br />
  <p class="bold">
    {{ 'case.create-quiz-information.reporting-url.title' | translate | capitalize }}
  </p>
  <p>
    {{ 'case.create-quiz-information.reporting-url.description' | translate | capitalize }}
  </p>
  <p>
    {{ 'case.create-quiz-information.reporting-url.url-explanation' | translate | capitalize }}
  </p>
  <div class="url-row">
    <mat-form-field appearance="outline" style="width: calc(100% - 50px)" [subscriptSizing]="'dynamic'">
      <input matInput type="text" disabled [(ngModel)]="reportingURL" />
    </mat-form-field>
    <button mat-icon-button [cdkCopyToClipboard]="reportingURL" (click)="copy()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
  <br />
  <p class="bold">
    {{ 'case.create-quiz-information.quiz-url.title' | translate | capitalize }}
  </p>
  <p>
    {{ 'case.create-quiz-information.quiz-url.description' | translate | capitalize }}
  </p>
  <p>
    {{ 'case.create-quiz-information.quiz-url.url-explanation' | translate | capitalize }}
  </p>
</div>
